

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"46","height":"45","xmlns":"http://www.w3.org/2000/svg"}, rest), [h('g', {"fill":"none","fill-rule":"evenodd"}, [h('ellipse', {"fill":"#FFF","cx":"22.535","cy":"22.468","rx":"22.535","ry":"22.468"}, []), h('path', {"d":"M14.56 31.529h19.287c.323 0 .584.26.584.58v1.302c0 .32-.261.58-.584.58H12.935a.853.853 0 01-.857-.85V11.504c0-.32.262-.58.585-.58h1.313c.323 0 .585.26.585.58v11.263l3.028-3.003c.484-.48 1.27-.48 1.755 0l4.924 4.883 5.304-5.26h-1.825a.582.582 0 01-.584-.58v-1.302c0-.32.262-.58.584-.58h5.207c.473 0 .856.38.856.85v5.162c0 .32-.262.58-.584.58h-1.314a.582.582 0 01-.584-.58v-1.81l-6.182 6.131c-.236.234-.551.36-.878.36-.327 0-.642-.126-.878-.36l-4.924-4.883-3.905 3.873v5.28z","fill":"#003E99","fill-rule":"nonzero"}, [])])]);
};

        